import { Toolbar } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomizedComponent = styled(Toolbar)(({ theme }) => ({
  "& .MuiToolbar-root": {
    position: "relative",
    display: "flex",
    minHeight: 64,
  },
}));

const OmniToolbar = props => {
  const { children, ...other } = props;
  return <CustomizedComponent {...other}>{children}</CustomizedComponent>;
};

export default OmniToolbar;
